import { ReactComponent as CardCountIcon } from './images/card_count.svg';
import { ReactComponent as CardComicsIcon } from './images/card_comics.svg';
import { ReactComponent as CardAiIcon } from './images/card_ai.svg';
import { ReactComponent as CardCosmosIcon } from './images/card_cosmos.svg';
import { ReactComponent as CardDegreeIcon } from './images/card_degree.svg';
import { ReactComponent as CardPaintAiIcon } from './images/card_paint_ai.svg';
import { ReactComponent as CardScienceIcon } from './images/card_science.svg';
import { ReactComponent as CardEvilIcon } from './images/card_evil.svg';
import { ReactComponent as CardWriterIcon } from './images/card_writer.svg';

export type CardType = {
  title: string;
  date: string;
  description: string;
  list: string[];
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
  color: string;
};

export type Price = {
  price: number;
  basePrice: number;
  discount: string;
  priceForLesson: number;
};

export const PRICE: Price = {
  price: 2920,
  basePrice: 5840,
  discount: '-50%',
  priceForLesson: 73,
};

export const DEFAULT_CARDS: CardType[] = [
  {
    title: 'Кем стать?',
    date: '12&nbsp;мая 15:00',
    description: 'Поможем понять, как любимое занятие превратить в будущую профессию',
    list: [
      '&bull; познакомимся с&nbsp;популярными профессиями',
      '&bull; разберемся, чему нужно научиться для этих профессий',
      '&bull; узнаем, как развить любимое занятие в&nbsp;навык',
    ],
    icon: CardDegreeIcon,
    bgColor: '#FFC2FC',
    color: '#8A8EE9',
  },
  {
    title: 'Как написать рассказ?',
    date: '19&nbsp;мая 15:00',
    description: 'Научим основам творческого письма',
    list: [
      '&bull; научимся создавать рассказ по&nbsp;частям&nbsp;&mdash; от&nbsp;вступления до&nbsp;заключения',
      '&bull; узнаем приемы творческого письма',
      '&bull; придумаем своих героев и&nbsp;события для рассказа',
    ],
    icon: CardWriterIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
  {
    title: 'Если кто-то обижает',
    date: '26&nbsp;мая 15:00',
    description: 'Научим решать конфликты',
    list: [
      '&bull; разберемся, как отличить дружеские шутки от&nbsp;травли',
      '&bull; научимся правильно реагировать и&nbsp;выражать свои чувства в&nbsp;конфликте',
      '&bull; узнаем, к&nbsp;кому обратиться за&nbsp;помощью',
    ],
    icon: CardEvilIcon,
    bgColor: '#FFD3A1',
    color: '#9B7BEC',
  },
];

// export const DEFAULT_CARDS: CardType[] = [
//   {
//     title: 'Считаю в уме',
//     date: '12&nbsp;марта 19:00',
//     description: 'Поможем развить навыки устного счета',
//     list: [
//       '&bull; научимся универсальным приемам устного счета',
//       '&bull; применим их&nbsp;в&nbsp;бытовых и&nbsp;игровых ситуациях',
//       '&bull; потренируемся находить удобные способы считать в&nbsp;уме',
//     ],
//     icon: CardCountIcon,
//     bgColor: '#E5D2FF',
//     color: '#8A8EE9',
//   },
//   {
//     title: 'Я — автор комикса',
//     date: '19&nbsp;марта 19:00',
//     description: 'Покажем, как создавать комикс',
//     list: [
//       '&bull; узнаем, что такое комикс и&nbsp;из&nbsp;чего он&nbsp;состоит',
//       '&bull; придумаем сюжет и&nbsp;героев',
//       '&bull; научимся передавать действия и&nbsp;эмоции героев через иллюстрации',
//       '&bull; оформим рассказ в&nbsp;последовательных кадрах',
//     ],
//     icon: CardComicsIcon,
//     bgColor: '#FFC2FC',
//     color: '#8A8EE9',
//   },
//   {
//     title: 'Знакомлюсь с&nbsp;нейросетью',
//     date: '24&nbsp;марта 19:00',
//     description: 'Познакомим с&nbsp;нейросетью легко и&nbsp;безопасно',
//     list: [
//       '&bull; узнаем, что такое искусственный интеллект и&nbsp;зачем он&nbsp;нужен',
//       '&bull; научимся формулировать запросы для точного результата',
//       '&bull; узнаем правила ответственного использования нейросетей',
//     ],
//     icon: CardAiIcon,
//     bgColor: '#FFF385',
//     color: '#D48AE9',
//   },
//   {
//     title: 'Нейросеть, нарисуй!',
//     date: '31&nbsp;марта 19:00',
//     description: 'Научим превращать текст в&nbsp;картинку с&nbsp;помощью нейросети',
//     list: [
//       '&bull; научимся описывать картинку словами для точного результата',
//       '&bull; создадим собственные изображения по&nbsp;заданной идее',
//       '&bull; узнаем правила ответственного использования нейросетей',
//     ],
//     icon: CardPaintAiIcon,
//     bgColor: '#E9FF89',
//     color: '#8A8EE9',
//   },
//   {
//     title: 'Я осваиваю космос',
//     date: '9&nbsp;апреля 19:00',
//     description: 'Расскажем о&nbsp;Солнечной системе и&nbsp;о&nbsp;тех, кто ее&nbsp;изучает',
//     list: [
//       '&bull; познакомимся с&nbsp;Солнцем и&nbsp;всеми планетами от&nbsp;Меркурия до&nbsp;Нептуна',
//       '&bull; изучим, чем отличаются планеты друг от&nbsp;друга и&nbsp;какие еще есть небесные тела',
//       '&bull; узнаем, чем занимаются астрономы и&nbsp;космонавты',
//     ],
//     icon: CardCosmosIcon,
//     bgColor: '#E5D2FF',
//     color: '#8A8EE9',
//   },
//   {
//     title: 'Фокусы или наука?',
//     date: '15&nbsp;апреля 19:00',
//     description: 'Расскажем, как наука объясняет удивительные явления',
//     list: [
//       '&bull; познакомимся с&nbsp;разными химическими явлениями',
//       '&bull; узнаем причины возникновения этих явлений',
//       '&bull; разовьем любознательность и&nbsp;критическое мышление',
//     ],
//     icon: CardScienceIcon,
//     bgColor: '#D2EEFF',
//     color: '#9B7BEC',
//   },
//   {
//     title: 'Я мечтаю стать…',
//     date: '20&nbsp;апреля 19:00',
//     description: 'Поможем понять, как любимое занятие превратить в будущую профессию',
//     list: [
//       '&bull; познакомимся с&nbsp;популярными профессиями',
//       '&bull; разберемся, чему нужно научиться для этих профессий',
//       '&bull; узнаем, как развить любимое занятие в&nbsp;навык',
//     ],
//     icon: CardDegreeIcon,
//     bgColor: '#FFC2FC',
//     color: '#8A8EE9',
//   },
//   {
//     title: 'Если кто-то обижает',
//     date: '29&nbsp;апреля 19:00',
//     description: 'Научим решать конфликты',
//     list: [
//       '&bull; разберемся, как отличить дружеские шутки от&nbsp;травли',
//       '&bull; научимся правильно реагировать и&nbsp;выражать свои чувства в&nbsp;конфликте',
//       '&bull; узнаем, к&nbsp;кому обратиться за&nbsp;помощью',
//     ],
//     icon: CardEvilIcon,
//     bgColor: '#FFD3A1',
//     color: '#9B7BEC',
//   },
//   {
//     title: 'Я — писатель',
//     date: '5&nbsp;мая 19:00',
//     description: 'Научим основам творческого письма',
//     list: [
//       '&bull; научимся создавать рассказ по&nbsp;частям&nbsp;&mdash; от&nbsp;вступления до&nbsp;заключения',
//       '&bull; узнаем приемы творческого письма',
//       '&bull; придумаем своих героев и&nbsp;события для рассказа',
//     ],
//     icon: CardWriterIcon,
//     bgColor: '#E5D2FF',
//     color: '#8A8EE9',
//   },
// ];

export const ONE_TO_MANY_SUBSCRIPTION_KEY = 'ONE_TO_MANY_SUBSCRIPTION_KEY';
export const ONE_TO_MANY_SUBSCRIPTION_AFTER_WEB_KEY = 'ONE_TO_MANY_SUBSCRIPTION_AFTER_WEB_KEY';
export const ONE_TO_MANY_SUBSCRIPTION_SEND_DOCUMENTS_KEY =
  'ONE_TO_MANY_SUBSCRIPTION_SEND_DOCUMENTS_KEY';
export const ONE_TO_MANY_SUBSCRIPTION_SEND_DOCUMENTS_AFTER_WEB_KEY =
  'ONE_TO_MANY_SUBSCRIPTION_SEND_DOCUMENTS_AFTER_WEB_KEY';
